import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {Title} from "../../../../../../stories/Title/Title";
import {Button} from "../../../../../../stories/Button/Button";
import {useNavigate} from "react-router-dom";
import {Label} from "../../../../../../stories/Label/Label";
import Input from "../../../../../../stories/Input/Input";
import {
  GridColDef,
  GridValidRowModel,
  GridAlignment,
  GridCellParams,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid-pro";
import {msgType, TableHeaderProps} from "../../../../../../utils/types";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../styles/AutocompleteStyles";
import {Keys, SpecialKeys} from "../../../../../../utils/Enum.keys";
import {
  CustomModal,
  handleMUISelectEvent,
  toInputStandardDate,
  toStandardDate,
} from "../../../../../../utils/UtilFunctions";
import {TextField} from "@mui/material";
import DataFetch from "../../../../../../images/OpenIcon.svg";
import {StyledDatagrid} from "../../../../../../styles/DatagridStyles";
import {TABLE_ROW_HEIGHT} from "../../../../../../styles/Variables";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import {
  AddModalStyles,
  ViewModalStyles,
} from "../../../../../../styles/CustomModalStyles";
import MrfDetails from "./MrfDetails";
import MrfItems from "./MrfItems";
import Enter from "../../../../../../images/Enter.svg";
import Edit from "../../../../../../images/EditProfile.svg";
import Delete from "../../../../../../images/Delete.svg";
import {ColumnVisibilityFor} from "../../../../../../utils/Enum.Datagrid";
import {GetSqlNumber} from "../../../../../../queries/queries";
import {
  GetSqlNumberResult,
  GetSqlNumberVars,
  tableKey,
} from "../../../../../../queries/types";
import {useLazyQuery} from "@apollo/client";

import {AppContext} from "../../../../../../context/context";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import {EMPTY_STRING, emptyMessage} from "../../../../../../utils/constants";
import SuppliersSelect from "../rfqtopo/components/SuppliersSelect";
import {GetSupplierByNodeId} from "../../../masters/supplier/queries/queries";
import {nodeVar} from "../../../../../../utils/commonQueryTypes";
import {
  AtsAcLdgr,
  LdgrQueryType,
} from "../../../masters/supplier/queries/types";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import {
  mrfToPoFormData,
  mrfToPoTableData,
} from "../../../../../../utils/formTypes";
import AddMrfModal from "../rfqtopo/components/AddMrfModal";
import {
  empType,
  LicenseTypes,
  Operation,
} from "../../../../../../utils/Enum.types";
import {payloadTypes} from "../../../../../../context/reducer";
import {
  AtsMrfMst,
  AtsMrfMstEdge,
  AtsMrfTrn,
} from "../../material/queries/types";
import MessageModal from "../../../../../../customComponents/MessageModal";
import {GetMrfByNode} from "../../material/queries/queries";
import DeleteModal from "../../../../../../customComponents/DeleteModal";
import Navbar from "../../../../../common/layout/Navbar";
import {useHotKey} from "../../../../../../utils/hotKeys";
import useLabels from "../../../../../../customHooks/useLabels";

const MRFtoPO = () => {
  const navigate = useNavigate();
  const {Purchase} = useAssetTableJson();
  const [mrfDetails, setMrfDetails] = useState(false);

  const {state, dispatch} = useContext(AppContext);
  const {customer_id, company_id} = useUrlParams();
  const {serverDate} = useServerDateandTime();
  const [addItemModal, setAddItemModal] = useState(false);
  const [operation, setOperation] = useState(Operation.CREATE);
  const [items, setItems] = useState<mrfToPoTableData[]>([]);

  const [selectedMrf, setSelectedMrf] = useState<AtsMrfMstEdge | null>(null);
  const [selectedItm, setSelectedItm] = useState<AtsMrfTrn | null>(null);

  const [message, setMessage] = useState<msgType>(emptyMessage);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deletedId, setDeletedId] = useState(0);

  const [remarks, setRemarks] = useState("");
  const {itemLabel} = useLabels();
  const initialValues: mrfToPoFormData = {
    mrfNo: "",
    mrfDate: "",
    slNo: "",
    udfItemDesc: "",
    itemUom: "",
    itemQty: "",
    itemRate: "",
    itemOther: "",
    itemTaxable: "",
    itemTax: "",
    itemInstChrg: "",
    itemDelvChrg: "",
    itemDeliveryDate: "",
    itemValue: "",
    netTotal: 0,
    itemID: 0,
    mrfTrnID: 0,
    mrfID: 0,
    remarks: "",
    itemDeliverySts: "",
  };

  const [formData, setFormData] = useState<mrfToPoFormData>(initialValues);

  const addRfqRef = useRef<HTMLButtonElement | null>(null);

  const [GetMrf, {data, loading}] = useLazyQuery<
    GetSqlNumberResult,
    GetSqlNumberVars
  >(GetSqlNumber);

  const [GetMrfById] = useLazyQuery<{node: AtsMrfMst}, nodeVar>(GetMrfByNode);

  const [GetSupplierDetails, {data: SupplierData}] = useLazyQuery<
    {
      node: AtsAcLdgr;
    },
    nodeVar
  >(GetSupplierByNodeId);

  const handleEdit = async (itm: mrfToPoTableData) => {
    setOperation(Operation.UPDATE);

    GetMrfById({
      variables: {
        id: itm.mrfID,
      },
    }).then(({data}) => {
      if (data && data.node) {
        setSelectedMrf({
          node: data.node,
          cursor: "",
        });
        dispatch({
          type: payloadTypes.SET_MRF_ID,
          payload: {
            mrfId: data.node.id,
          },
        });
        const foundItem = data.node.rfqCompletedItems.find(
          (trn) => trn.id === itm.mrfTrnID
        );

        if (foundItem) setSelectedItm(foundItem as AtsMrfTrn);
        const total =
          Number(itm.itemQty) * Number(itm.itemRate) +
          Number(itm.itemDelvChrg) +
          Number(itm.itemInstChrg) +
          Number(itm.itemOther);
        setFormData({
          udfItemDesc: itm.udfItemDesc,
          slNo: itm.slNo.toString(),
          itemUom: itm.itemUom,
          itemQty: itm.itemQty.toString(),
          itemRate: itm.itemRate.toString(),
          itemOther: itm.itemOther.toString(),
          itemTaxable: itm.itemTaxable.toString(),
          itemTax: itm.itemTax.toString(),
          itemDelvChrg: itm.itemDelvChrg.toString(),
          itemInstChrg: itm.itemInstChrg.toString(),
          itemValue: itm.itemValue.toString(),
          remarks: itm.remarks,
          itemDeliverySts: itm.itemDeliverySts.toString(),
          itemDeliveryDate: itm.itemDeliveryDate,
          itemID: itm.itemID,
          mrfTrnID: itm.mrfTrnID,
          mrfID: itm.mrfID,
          mrfDate: itm.mrfDate,
          mrfNo: itm.mrfNo,
          netTotal:
            Number(itm.itemQty) * Number(itm.itemRate) +
            Number(itm.itemDelvChrg) +
            Number(itm.itemInstChrg) +
            Number(itm.itemOther) +
            (Number(itm.itemTax) / 100) * total,
        });
      }
    });
    setAddItemModal(true);
  };

  const dynamicHeaders: TableHeaderProps[] = Purchase.PurchaseOrder.MrfToPo.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
      renderCell: (params) => {
        if (header.field === "actions") {
          return (
            <>
              <img
                src={Edit}
                alt=""
                onClick={() => {
                  const foundItem = items.find(
                    (itm, index) => index + 1 === params.row.id
                  );
                  if (foundItem) {
                    handleEdit(foundItem);
                  }
                }}
              />
              <img
                src={Delete}
                alt=""
                onClick={() => {
                  setDeletedId(params.row.id);
                  setDeleteModal(!deleteModal);
                }}
              />
            </>
          );
        }
        return params.value;
      },
    })
  );

  const columns: GridColDef[] = [...dynamicHeaders];
  const rows: GridValidRowModel[] = [
    ...items.map((data, index) => {
      const total =
        Number(data.itemQty) * Number(data.itemRate) +
        Number(data.itemInstChrg) +
        Number(data.itemDelvChrg) +
        Number(data.itemOther);

      return {
        id: index + 1, // Start IDs from 2
        approved_mrf_no: data.mrfNo,
        mrf_date: toStandardDate(data.mrfDate),
        mrf_sl_no: "",
        item_desc: data.udfItemDesc,
        itemUom: data.itemUom,
        // warranty: 0,
        qty: data.itemQty,
        rate: data.itemRate,
        other_charges: data.itemOther,
        taxable_rate: data.itemTaxable,
        tax_perc: data.itemTax,
        total,
        any_installation: data.itemInstChrg,
        delivery_charges: data.itemDelvChrg,
        delivery_date: toStandardDate(data.itemDeliveryDate),
        net_total: (Number(data.itemTax) / 100) * Number(data.itemTaxable),
        actions: 0,
      };
    }),
  ];

  const total = useMemo(() => {
    const totals = items.reduce(
      (acc, itm) => {
        acc.qty = acc.qty + Number(itm.itemQty);
        acc.rate = acc.rate + Number(itm.itemRate);
        acc.other_charges = acc.other_charges + Number(itm.itemOther);
        acc.taxable_rate = acc.taxable_rate + Number(itm.itemTaxable);
        acc.total = acc.total + Number(itm.itemValue);
        acc.any_installation = acc.any_installation + Number(itm.itemInstChrg);
        acc.delivery_charges = acc.delivery_charges + Number(itm.itemDelvChrg);
        acc.net_total = acc.net_total + Number(itm.netTotal);
        return acc;
      },
      {
        qty: 0,
        rate: 0,
        other_charges: 0,
        taxable_rate: 0,
        total: 0,
        any_installation: 0,
        delivery_charges: 0,
        net_total: 0,
      }
    );
    return [
      {
        id: [],
        approved_mrf_no: [],
        mrf_date: [],
        mrf_sl_no: [],
        item_desc: [],
        itemUom: "",
        warranty: "Total",
        qty: totals.qty,
        rate: totals.rate,
        other_charges: totals.other_charges,
        taxable_rate: totals.taxable_rate,
        tax_perc: [],
        total: totals.total,
        any_installation: totals.any_installation,
        net_total: totals.net_total,
        actions: [],
      },
    ];
  }, [items]);

  const pinnedRows = {
    bottom: total,
  };

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "other_charges":
        case "rate":
        case "qty":
        case "taxable_rate":
        case "total":
        case "any_installation":
        case "net_total":
          return "total-count";
        case "warranty":
          return "total";
        default:
          return "hide-td";
      }
    }

    return "";
  };
  // const handleMRFRow = (argFormData: rfqPoFormData) => {
  //   if (state.rfqId) {
  //     if (operation === Operation.UPDATE) {
  //       const filteredItem = items.filter(
  //         (itm) => itm.slNo !== Number(argFormData.slNo)
  //       );
  //       const foundDuplicate = filteredItem.find(
  //         (itm) =>
  //           itm.rfqID === argFormData.rfqID && itm.itemID === argFormData.itemID
  //       );

  //       if (foundDuplicate) {
  //         setMessage({
  //           flag: true,
  //           message: "Item with same rfq already exists",
  //           operation: Operation.NONE,
  //         });
  //       } else {
  //         const updateItems: rfqPoTableData[] = items.map((itm) => {
  //           if (state.rfqId && itm.slNo === Number(argFormData.slNo)) {
  //             return {
  //               ...argFormData,
  //               itemQty: Number(argFormData.itemQty),
  //               itemRate: Number(argFormData.itemRate),
  //               itemOther: Number(argFormData.itemOther),
  //               itemTaxable: Number(argFormData.itemTaxable),
  //               itemTax: Number(argFormData.itemTax),
  //               itemValue: Number(argFormData.itemValue),
  //               itemInstChrg: Number(argFormData.itemInstChrg),
  //               itemDelvChrg: Number(argFormData.itemDelvChrg),
  //               slNo: Number(argFormData.slNo),
  //               itemDeliverySts: Number(argFormData.itemDeliverySts),
  //               itemDeliveryDate: argFormData.itemDeliveryDate,
  //             } as rfqPoTableData;
  //           } else {
  //             return itm;
  //           }
  //         });
  //         setItems(updateItems);
  //         setOperation(Operation.CREATE);
  //       }
  //     } else {
  //       const index = items.length;

  //       const foundDuplicate = items.find(
  //         (itm) =>
  //           itm.rfqID === argFormData.rfqID && itm.itemID === argFormData.itemID
  //       );

  //       if (foundDuplicate) {
  //         setMessage({
  //           flag: true,
  //           message: "Item already exists",
  //           operation: Operation.NONE,
  //         });
  //       } else {
  //         if (state.rfqId) {
  //           setItems((prev) => [
  //             {
  //               ...argFormData,
  //               itemQty: Number(argFormData.itemQty),
  //               itemRate: Number(argFormData.itemRate),
  //               itemOther: Number(argFormData.itemOther),
  //               itemTaxable: Number(argFormData.itemTaxable),
  //               itemTax: Number(argFormData.itemTax),
  //               itemValue: Number(argFormData.itemValue),
  //               itemInstChrg: Number(argFormData.itemInstChrg),
  //               itemDelvChrg: Number(argFormData.itemDelvChrg),
  //               slNo: Number(index),
  //               itemDeliverySts: Number(argFormData.itemDeliverySts),
  //             },
  //             ...prev,
  //           ]);
  //         }
  //         setMessage({
  //           flag: true,
  //           message: "Added item successfully",
  //           operation: Operation.CREATE,
  //         });
  //       }
  //     }
  //   }
  //   dispatch({
  //     type: payloadTypes.SET_RFQ_ID,
  //     payload: {
  //       rfqId: 0,
  //     },
  //   });
  //   setFormData(initialValues);
  // };
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  const handleDelete = (id: number) => {
    setDeleteModal(!deleteModal);
    const updatedItems = items.filter((itm, index) => index + 1 !== id);
    setItems(updatedItems);
  };
  const handleMRFRow = (argFormData: mrfToPoFormData) => {
    if (state.mrfId) {
      if (operation === Operation.UPDATE) {
        const filteredItem = items.filter(
          (itm) => Number(itm.slNo) !== Number(argFormData.slNo)
        );
        const foundDuplicate = filteredItem.find(
          (itm) =>
            itm.mrfID === argFormData.mrfID && itm.itemID === argFormData.itemID
        );

        if (foundDuplicate) {
          setMessage({
            flag: true,
            message: `${itemLabel} with same rfq already exists`,
            operation: Operation.NONE,
          });
        } else {
          const updateItems: mrfToPoTableData[] = items.map((itm) => {
            if (state.mrfId && Number(itm.slNo) === Number(argFormData.slNo)) {
              return {
                ...argFormData,
                itemQty: argFormData.itemQty,
                itemRate: argFormData.itemRate,
                itemOther: argFormData.itemOther,
                itemTaxable: argFormData.itemTaxable,
                itemTax: argFormData.itemTax,
                itemValue: argFormData.itemValue,
                itemInstChrg: argFormData.itemInstChrg,
                itemDelvChrg: argFormData.itemDelvChrg,
                slNo: argFormData.slNo,
                itemDeliverySts: argFormData.itemDeliverySts,
                itemDeliveryDate: argFormData.itemDeliveryDate,
              } as mrfToPoTableData;
            } else {
              return itm;
            }
          });
          setItems(updateItems);
          setOperation(Operation.CREATE);
        }
        setAddItemModal(!addItemModal);
      } else {
        const index = items.length;

        const foundDuplicate = items.find(
          (itm) =>
            itm.mrfID === argFormData.mrfID && itm.itemID === argFormData.itemID
        );

        if (foundDuplicate) {
          setMessage({
            flag: true,
            message: `${itemLabel} already exists`,
            operation: Operation.NONE,
          });
        } else {
          if (state.mrfId) {
            setItems((prev) => [
              {
                ...argFormData,
                itemQty: argFormData.itemQty,
                itemRate: argFormData.itemRate,
                itemOther: argFormData.itemOther,
                itemTaxable: argFormData.itemTaxable,
                itemTax: argFormData.itemTax,
                itemValue: argFormData.itemValue,
                itemInstChrg: argFormData.itemInstChrg,
                itemDelvChrg: argFormData.itemDelvChrg,
                slNo: index.toString(),
                itemDeliverySts: argFormData.itemDeliverySts,
              },
              ...prev,
            ]);
          }
          setMessage({
            flag: true,
            message: "Added item successfully",
            operation: Operation.CREATE,
          });
        }
      }
    }
    dispatch({
      type: payloadTypes.SET_MRF_ID,
      payload: {
        mrfId: 0,
      },
    });
    setFormData(initialValues);
  };

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.MRF_TO_PO);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.MRF_TO_PO,
      JSON.stringify(newModel)
    );
  };

  useEffect(() => {
    if (customer_id && company_id && state.ActiveFinYr) {
      GetMrf({
        variables: {
          customerID: customer_id,
          companyID: company_id,

          tableKey: tableKey.PO,
        },
      });
    }
  }, [GetMrf, customer_id, company_id, state.ActiveFinYr]);

  useEffect(() => {
    GetSupplierDetails({
      variables: {
        id: state.supplierId,
      },
    });
  }, [GetSupplierDetails, state.supplierId]);

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      setMessage(emptyMessage);
    }
  };
  const handleClear = () => {
    dispatch({
      type: payloadTypes.SET_SUPPLIER_ID,
      payload: {
        supplierId: 0,
      },
    });
    setItems([]);
    setRemarks("");
  };

  useHotKey({
    handleFunc: () => {
      setAddItemModal(!addItemModal);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />
      <Title>MRF to PO</Title>
      <div className="mrf-to-po">
        <div className="mrf-to-po__details row g-0">
          <div className="col mrf-to-po__details--frame">
            <div className="label-grid">
              <Label>Purchase Order No.</Label>
              <Input
                disabled
                value={data ? data.GetSqlNumber.sqlNumber : EMPTY_STRING}
              />
              <Label>Choose Supplier</Label>
              {state.empSubType !== empType.VENDOR_MANAGER ? (
                <div className="mrf-to-po__details--frame--flex">
                  <SuppliersSelect
                    autoFocus={true}
                    onKeyDown={(e) => {
                      if (e.key === Keys.ENTER) {
                      }
                    }}
                    icon={true}
                    input={{
                      itemID: 0,
                      query_type: LdgrQueryType.ALL,
                      tableLevel: undefined,
                    }}
                  />
                </div>
              ) : null}
            </div>
            <div className="mrf-to-po__details--frame--grid">
              <Label>GSTIN No.</Label>
              <Input
                disabled
                value={
                  SupplierData
                    ? SupplierData.node.supplier_details.gstNo
                    : EMPTY_STRING
                }
              />

              <Label>City</Label>
              <Input
                disabled
                value={
                  SupplierData
                    ? SupplierData.node.supplier_details.city
                    : EMPTY_STRING
                }
              />
            </div>
          </div>
          <div className="col mrf-to-po__details--frame">
            <div className="label-grid">
              <Label>Date</Label>
              <Input type="date" value={toInputStandardDate(serverDate)} />
            </div>
          </div>
        </div>
        <div className="row g-0">
          <div className="col flex-end">
            <Button
              mode="addnew"
              buttonref={addRfqRef}
              onClick={() => setAddItemModal(!addItemModal)}
            >
              {" "}
              MRF
            </Button>
          </div>
        </div>
        <div className="mrf-to-po__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel,
              },
            }}
            getCellClassName={getCellClassName}
            pinnedRows={pinnedRows}
            getRowClassName={(params) =>
              params.row.id === 1 ? "mrf-to-po__tableblock--edit-row" : ""
            }
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        <div className="mrf-to-po__terms row g-0">
          <div className="col">
            <div className="label-grid">
              <Label>Remarks</Label>
              <TextArea
                rows={2}
                value={remarks}
                onChange={(e) => {
                  setRemarks(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="col">
            {/* <div className="label-grid">
              <Label>Terms</Label>
              <Input />
            </div> */}
          </div>
        </div>
        <Button mode="save" />
        <Button mode="clear" onClick={handleClear} />
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>
      <CustomModal
        isOpen={mrfDetails}
        onRequestClose={() => setMrfDetails(false)}
        contentComponent={<MrfDetails setModalFlag={setMrfDetails} />}
        style={ViewModalStyles}
      />
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <DeleteModal
        id={deletedId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={handleDelete}
      />
      <CustomModal
        isOpen={addItemModal}
        onRequestClose={() => setAddItemModal(!addItemModal)}
        style={AddModalStyles}
        contentComponent={
          <AddMrfModal
            operation={operation}
            hanldeItemRow={handleMRFRow}
            itemsCount={items.length}
            setModal={setAddItemModal}
            formDataState={{
              formData,
              setFormData,
            }}
            editState={{
              editItm: selectedItm,
              editRfq: selectedMrf,
            }}
          />
        }
      />
      {/* <CustomModal
        isOpen={addItemModal}
        onRequestClose={() => setAddItemModal(!addItemModal)}
        style={AddModalStyles}
        contentComponent={
          <AddRfqModal
            operation={operation}
            hanldeItemRow={handleMRFRow}
            itemsCount={items.length}
            setModal={setAddItemModal}
            formDataState={{
              formData,
              setFormData,
            }}
            editState={{
              editItm: selectedItm,
              editRfq: selectedRfq,
            }}
          />
        }
      /> */}
    </>
  );
};

export default MRFtoPO;
